import React, { FC, useEffect, useState } from 'react'
import { CurrentUserType } from 'src/ducks/auth'
import LoadIcon from '../../components/LoadIcon'
import { LobbyEntry } from '../../components/LobbyEntry'
import PageWithBg from '../../components/PageWithBg'
import config from '../../config'
import Amplitude from '../../utils/amplitudeHelper'
import { StyledLobby } from './styled'
import QR from '../../images/event/MMA.jpg'
import { useDispatch } from 'react-redux'
import { showGlobalModal } from '../../ducks/layout'
import { GlobalModalTypes } from '../../components/GlobalModals/GlobalModalContainer'
import { useObject } from 'react-firebase-hooks/database'
import { QRcodeDb } from '../../firebaseConfig'

export const LobbyPage: FC<{ currentUser: CurrentUserType }> = ({ currentUser }) => {
  const [isLoading, setIsLoading] = useState(true)
  const dispatch = useDispatch()
  const [snapshot, snapshotLoading, snapshotError] = useObject(QRcodeDb)

  useEffect(() => {
    document.title = `${config.eventName} | Lobby`
  }, [])

  useEffect(() => {
    Amplitude.visit('Lobby')
  }, [currentUser.id])

  const toggleQR = () => {
    dispatch(showGlobalModal(GlobalModalTypes.CPD))
    Amplitude.showQR()
  }
  return (
    <>
      {isLoading && <LoadIcon />}
      <StyledLobby>
        <PageWithBg bgImg={config.assets.lobby.landscape}>
          {config.lobbyEntries.map((entry) => {
            return <LobbyEntry key={entry.id} {...entry} currentUser={currentUser} />
          })}
          <div className="trailer">
            {(!snapshotLoading && !snapshotError && snapshot && snapshot.val() === "on") ?
              <img src={QR} alt="QR code" id="banner" onClick={toggleQR} />
              :
              <iframe
                width="100%"
                height="100%"
                title="Lobby Vimeo"
                src="https://player.vimeo.com/video/696339512?autoplay=1"
                allow="autoplay; fullscreen"
                allowFullScreen
                frameBorder="0"
                onLoad={() => {
                  setIsLoading(false)
                }}
              />
            }
          </div>
          <div id="current-user">Logged in as {currentUser.email}</div>
        </PageWithBg>
      </StyledLobby>
    </>
  )
}
